<span class="label label-proposed" *ngIf="state === stateEnum.PROPOSED">Proposed</span>
<span class="label label-accepted" *ngIf="state === stateEnum.ACCEPTED">Accepted</span>
<span class="label label-activated" *ngIf="state === stateEnum.ACTIVATED">Activated</span>
<span class="label label-ended" *ngIf="state === stateEnum.CLOSED">Closed</span>
<span class="label label-non-conforming" *ngIf="state === stateEnum.NONCONFORMING">Non-Conforming</span>
<span class="label label-contingent" *ngIf="state === stateEnum.ROGUE">Contingent</span>
<span class="label label-rejected" *ngIf="state === stateEnum.REJECTED">Rejected</span>
